const ROUTES = {
  HOME: '/',
  LANDING_CONTROL: '/landing-control',
  LANDING_VARIANT: '/landing-variant',
  DASHBOARD: '/dashboard',

  PEDAGOGY: '/pedagogy',
  VISION: '/vision',

  BOOKING: '/booking',
  BOOKING_CHECKOUT: '/booking/checkout',
  BOOKING_CHECKOUT_COMPLETE: '/booking/checkout/complete',
  BOOKING_FOR_OTHER: '/booking/for-other',
  MULT_GAME_SIGNUP: '/games/multgame/register',
  BOOKING_FOR_SELF: '/booking/for-self',
  SESSION_PAGE: '/session',

  COMPLETE_PROFILE: '/complete-profile',
  RESET_PASSWORD: '/reset-password',
  RECOVER_PASSWORD: '/recover-password',
  LOGIN: '/login',
  MULT_GAME_LOGIN: '/games/multgame/login',
  STACKNLOAD_LOGIN: '/games/stacknload/login',
  JUNIOR_MATH_LOGIN: '/games/junior-math/login',
  TREASURETRAIL_LOGIN: '/games/treasure-trail/login',
  WINDSURFER_LOGIN: '/games/windsurfer/login',
  REGISTER: '/register',

  // School edition only. Everything the pilot owns lives under `/school`, EXCEPT `CLASSROOM_JOIN`:
  // a teacher puts that one on a projector and children type it by hand, so it stays short.
  //
  // ⚠ The only place any pilot URL is written down — every link and `router.push` is built from
  // these. A literal in a component is a URL the next move silently leaves behind.
  CLASSROOM_JOIN: '/join',
  CLASSROOM_STUDENT_LOGIN: '/school/student/login',
  CLASSROOM_TEACHER_LOGIN: '/school/teacher/login',
  CLASSROOM_CLASSES: '/school/teacher/classes',
  CLASSROOM_TEACHER_DASHBOARD: '/school/teacher/dashboard',
  // Plural `students`, so it does not read as one of the pupil's own `/school/student/*` screens: this
  // is a teacher's view of someone else. The pupil's id and `/stats` are appended — see
  // `studentStatsHref`.
  CLASSROOM_STUDENT_STATS: '/school/students',
  CLASSROOM_WELCOME: '/school/student/welcome',
  // Where the district's identity provider sends the browser back to. Registered with them verbatim,
  // so changing this string means re-registering it in every district's Okta.
  CLASSROOM_SSO_CALLBACK: '/school/auth/sso/callback',

  ADMIN_PANEL: '/admin',
  // School edition only, and a real page rather than a tab: `pages/admin/[tab].tsx` would otherwise
  // swallow it, and a static route wins over a dynamic sibling. Staff need a door in that edition
  // because `/login` redirects to role selection there.
  ADMIN_LOGIN: '/admin/login',
  ADMIN_PANEL_TUTORS: '/admin/tutors',
  ADMIN_PANEL_SETTINGS: '/admin/settings',
  ADMIN_PANEL_STUDENTS: '/admin/students',
  ADMIN_PANEL_USERS: '/admin/users',
  ADMIN_PANEL_STATISTICS: '/admin/statistics',
  ADMIN_PANEL_VIDEO_CHAT: '/admin/video-chats',
  ADMIN_PANEL_SCHEDULE: '/admin/schedule',
  ADMIN_PANEL_STRIPE: '/admin/stripe',
  ADMIN_PANEL_PERMISSONS: '/admin/permissions',
  ADMIN_PANEL_FEATURE_FREE_ACCESS_DURATION: '/admin/product-time-open',
  ADMIN_PANEL_TSHIRTS: '/admin/tshirts',
  ADMIN_PANEL_SCHOOLS: '/admin/schools',
  ADMIN_PANEL_SCHOOL_CLASSROOMS: '/admin/school-classrooms',
  ADMIN_PANEL_SCHOOL_TEACHERS: '/admin/school-teachers',
  ADMIN_PANEL_SCHOOL_IMPORT: '/admin/school-import',

  TUTOR_PAGE: '/tutor/:tutorId',
  TUTOR_PANEL: '/tutor',
  TUTOR_PANEL_ACADEMY: '/tutor/academy',
  TUTOR_PANEL_CHAT: '/tutor/chat',
  TUTOR_PANEL_HOME: '/tutor/home',
  TUTOR_PANEL_SETTINGS: '/tutor/settings',
  TUTOR_PANEL_SCHEDULE_DATE: '/tutor/students/schedule/date',
  TUTOR_PANEL_SCHEDULE_INFO: '/tutor/students/schedule/info',
  TUTOR_PANEL_SCHEDULE_TIME: '/tutor/students/schedule/time',
  TUTOR_PANEL_STUDENTS: '/tutor/students',
  TUTOR_PANEL_VIDEO_CHAT: '/tutor/video-chat',

  STUDENT_PAGE: '/student/:studentId',
  STUDENT_PANEL: '/student',
  STUDENT_PANEL_APPOINTMENTS: '/student/appointments',
  STUDENT_PANEL_MY_TUTOR: '/student/my-tutor',
  STUDENT_PANEL_RECEIPTS: '/student/receipts',
  STUDENT_PANEL_SETTINGS: '/student/settings',

  STUDENT_PANEL_OBSERVER: '/student/observer',
  STUDENT_PANEL_OBSERVER_DETAIL: '/student/observer/[studentId]',
  STUDENT_PANEL_OBSERVER_APPOINTMENTS: '/student/observer/[studentId]/appointments',
  STUDENT_PANEL_OBSERVER_TUTORS: '/student/observer/[studentId]/tutors',

  TUTOR_ON_DEMAND: '/tutor-on-demand',
  TUTOR_ON_DEMAND_INFORMATION: '/tutor-on-demand/information',
  TUTOR_ON_DEMAND_BLOG: '/tutor-on-demand/blog',
  TUTOR_ON_DEMAND_BIOLOGY: '/tutor-on-demand/biology',
  TUTOR_ON_DEMAND_CHEMISTRY: '/tutor-on-demand/chemistry',
  TUTOR_ON_DEMAND_ECONOMY: '/tutor-on-demand/economy',
  TUTOR_ON_DEMAND_FINANCE: '/tutor-on-demand/finance',
  TUTOR_ON_DEMAND_MATH: '/tutor-on-demand/math',
  TUTOR_ON_DEMAND_OTHER_SUBJECTS: '/tutor-on-demand/other-subjects',
  TUTOR_ON_DEMAND_PHYSICS: '/tutor-on-demand/physics',
  TUTOR_ON_DEMAND_STATISTICS: '/tutor-on-demand/statistics',

  MEDIA: '/media',
  MEDIA_MEDIABANK: '/media/mediabank',
  MEDIA_NEWS: '/media/news',
  MEDIA_PRESS_RELEASES: '/media/press-releases',

  ACHIEVEMENTS: '/achievements',
  ACHIEVEMENTS_LEGACY: '/achievements/legacy',
  ABOUT: '/about',
  COOKIE_POLICY: '/cookie-policy',
  LEADERBOARD: '/leaderboard',
  LECTURES: '/lectures',
  OUR_TEAM: '/our-team',
  PRIVACY: '/privacy',
  TERMS: '/terms-and-conditions',
  GOOGLE_POLICY: 'https://policies.google.com/privacy',
  PURCHASE_AGREEMENT_TUTORING: '/purchase-agreement/tutoring',
  PURCHASE_AGREEMENT_VIDEO_CHAT: '/purchase-agreement/video-chat',
  AVAILABLE_STUDENTS: '/available-student/:code',
  AVATAR: '/avatar',
  AVATAR_MULT_GAME: '/avatar-multgame',
  BOOTCAMP: '/bootcamp',
  BOOTCAMP_OVERVIEW: '/bootcamp/:key',
  BOOTCAMP_SUBJECT_OVERVIEW: '/bootcamp/[subTopic]',
  BOOTCAMP_MODULE_OVERVIEW: '/bootcamp/[subTopic]/[key]',
  BOOTCAMP_MODULE: '/bootcamp/:key/:moduleKey/:level/:action',
  BOOTCAMP_ACTIVITY: '/bootcamp/[subtopic]/[key]/[moduleKey]/[level]/[action]',
  BOOTCAMP_MULTIPLICATION: '/bootcamp/numbers-and-quantities/multiplication',
  BOOTCAMP_SELECT_GRADE: '/bootcamp/select-grade',
  BOOTCAMP_SELECT_GRADE_MARKETING: '/bootcamp/select-grade/grade-country',
  DIGITAL_TOOL: '/digital-tools',
  DRILL: '/drill',
  DRILL_CONTENT: '/drill/:content/',
  DRILL_CONTENT_FILE: '/drill/:content/:file',
  ENCYCLOPEDIA: '/encyclopedia',
  JUNIOR_DRILL: '/juniordrill',
  EXAMS: '/exams',
  EXCEL: '/excel',
  GAMES: '/games',
  GEOGEBRA: '/geogebra',
  MULT_GAME: '/games/multgame',
  STACKNLOAD: '/games/stacknload',
  TREASURETRAIL: '/games/treasure-trail',
  WINDSURFER: '/games/windsurfer',
  SEARCH_RESULT: '/search-result',
  SETTINGS: '/settings',
  STUDY_TIPS: '/study-tips',
  TEX_LINK: '/_tex_link',
  AUTH_CALLBACK: '/auth',
  FACEBOOK_CALLBACK: '/auth/facebook/callback',
  PANEL: '/panel',
  CHAMPIONSHIP: '/games/multgame?championship=hom',

  MATH_VAULT: '/math-vault',
  MATH_VAULT_SITE_MAP: '/math-vault/site-map',

  ZOOM_AUTHENTICATION: '/zoom',

  EMAIL_VERIFY: '/email-verify',

  PARTNER: '/p',
  CAMPAIGNS: '/campaigns',
  CAMPAIGNS_ACCENTURE: '/campaigns/accenture',
  ACCENTURE_LEADERBOARD: '/leaderboard/accenture',
  SUBSCRIPTION_CHECKOUT_PAYMENT: '/subscription/checkout/payment',
  SUBSCRIPTION_CHECKOUT_FAMILY_ADMIN: '/subscription/checkout/family-admin',
  SUBSCRIPTION_CHECKOUT_SIGNUP: '/subscription/checkout/signup',
  SUBSCRIPTION_CHECKOUT_LOGIN: '/subscription/checkout/login',
  SUBSCRIPTION_CHECKOUT_COMPLETE: '/subscription/checkout-complete',
  SUBSCRIPTION_UPGRADE_COMPLETE: '/subscription/upgrade-complete',
  ADYEN_CALLBACK_PAGE: '/adyen/callback',
  VIPPS_CALLBACK_PAGE: '/vipps/callback',
  START: '/start',

  ONBOARDING: '/onboarding',
  ONBOARDING_ACCOUNT_TYPE: '/onboarding/account-type',
  ONBOARDING_BIRTHYEAR: '/onboarding/birthyear',
  ONBOARDING_AVATAR: '/onboarding/avatar',
  ONBOARDING_DETAILS: '/onboarding/details',
  ONBOARDING_UPDATE_EMAIL: '/onboarding/update-email',
  ONBOARDING_EMAIL_VERIFY: '/onboarding/email-verify',
  ONBOARDING_SELECT_GRADE: '/onboarding/select-grade',
  ONBOARDING_NICKNAME: '/onboarding/nickname',
  ONBOARDING_SELECT_GRADE_COUNTRY_CODE: '/onboarding/select-grade/[countryCode]',
  ONBOARDING_SELECT_GRADE_MARKETING: '/onboarding/select-grade/grade-country',
  ONBOARDING_SUBSCRIBE: '/onboarding/subscribe',
  ONBOARDING_PRODUCT_VIDEO: '/onboarding/product-video',

  // family
  FAMILY: '/family',
  FAMILY_SWITCH_PROFILE: '/family/switch-profile',
  FAMILY_CREATE_PROFILE: '/family/admin/add-learner',
  FAMILY_EDIT_PROFILE: '/family/admin/edit-profile',
  FAMILY_INVITATION: '/family/admin/invite',
  FAMILY_INVITATION_PENDING: '/family/admin/invite-pending',
  FAMILY_ACCEPT_INVITE: '/family/accept',
  FAMILY_ADMIN_PANEL: '/family/admin',
  FAMILY_LINK_SETUP_ACCOUNT: '/family/link-setup-account',
  FAMILY_STATS: '/family/admin/stats',
  FAMILY_MANAGE_SUBSCRIPTION: '/family/admin/manage-subscription',
  FAMILY_MANAGE_ADD_LICENSE: '/family/admin/manage-subscription/add-license',
  FAMILY_MANAGE_REMOVE_LICENSE: '/family/admin/manage-subscription/remove-license',
  FAMILY_MANAGE_CONFIRMATION: '/family/admin/manage-subscription/confirmation',
  FAMILY_REACTIVATE_SUBSCRIPTION: '/family/admin/manage-subscription/reactivate-subscription',
  FAMILY_PACK_CREATOR: '/onboarding/family-pack-creator',
  FAMILY_ADMIN_SET_PIN: '/family/admin/set-pin',
  FAMILY_ADMIN_EDIT_PIN: '/family/admin/edit-pin',
  FAMILY_ADMIN_FAMILY_PASSWORD: '/family/admin/family-password',
  FAMILY_ADMIN_ACCOUNT: '/family/admin/account',
  FAMILY_ADMIN_FAQ: '/family/admin/faq',
  FAMILY_UPGRADE: '/subscription/upgrade',
  FAMILY_FORGOT_PIN: '/family/forgot-pin',
  FAMILY_ADMIN_SETUP_ACCESS: '/family/admin/setup-access',

  CURRICULUM: '/curriculum',
  CURRICULUM_MAPPING_QUIZ: '/mapping-quiz',

  PROFILES: '/profiles',

  STATISTICS: '/my-statistics',

  DEV: '/_dev',

  NOT_FOUND: '/404', //  Page not found
  REMOVED: '/410', // Page removed
  NO_MATCH: '*', // 404 or Page not found when don't match any route

  SUBSCRIPTION_PAGE: '/subscription',
  FAQ: '/faq',

  MATHMAGIC: '/mathmagic',
  MATHMAGIC_MEDIA: '/mathmagic/media',
  MATHMAGIC_ESG: '/mathmagic/esg',
  MATHMAGIC_SPONSORS: '/mathmagic/sponsors',
  MATHMAGIC_DONATE: '/mathmagic/donate',
  MATHMAGIC_DONATE_CHECKOUT: '/mathmagic/donate/checkout',
  MATHMAGIC_DONATE_CONFIRMATION: '/mathmagic/donate/confirmation',
  MATH_TOPICS: '/math-topics',
  DNB_CAMPAIGN_TOD: '/no/campaigns/dnb/saga-private-banking',
  DNB_CAMPAIGN_UNG_PLUS: '/no/campaigns/dnb/ung-pluss',
  REFERRAL: '/referral',

  GET_STARTED: '/get-started',
  GET_STARTED_INTRO: '/get-started/intro',
  // Parked A/B arms. Middleware rewrites /get-started/intro to one of these while an onboarding
  // test runs, so the URL never changes; with no test live both render the same funnel as intro.
  GET_STARTED_CONTROL: '/get-started/control',
  GET_STARTED_VARIANT: '/get-started/variant',
  GET_STARTED_SIGNUP: '/get-started/signup',
  GET_STARTED_PRICE: '/get-started/price',
  GET_STARTED_FEEDBACK: '/get-started/feedback',
  GET_STARTED_ROLE: '/get-started/role',
  GET_STARTED_US_ROLE: '/get-started/us/role',

  GET_STARTED_V2_WELCOME: '/get-started/v2/welcome',
  GET_STARTED_V2_GRADE: '/get-started/v2/grade',
  GET_STARTED_V2_PROBLEM: '/get-started/v2/problem',
  GET_STARTED_V2_BREAKDOWN: '/get-started/v2/breakdown',
  GET_STARTED_V2_TRIED: '/get-started/v2/tried',
  GET_STARTED_V2_RESULT: '/get-started/v2/result',
  GET_STARTED_V2_MATH_PLAN: '/get-started/v2/math-plan',

  GET_STARTED_DIRECT_PRICE: '/get-started/direct/price',
  GET_STARTED_DIRECT_SIGNUP: '/get-started/direct/signup',

  GET_STARTED_WANT_TO_IMPROVE: '/get-started/want-to-improve',
  GET_STARTED_STATS: '/get-started/stats',
  GET_STARTED_INSIGHT: '/get-started/insight',
  GET_STARTED_PERFORMANCE: '/get-started/performance',
  GET_STARTED_FREQUENCY: '/get-started/frequency',
  GET_STARTED_RESULT: '/get-started/result',

  ONBOARDING_FLOW_SIGNUP: '/onboarding-flow/signup',
  ONBOARDING_FLOW_PAYMENT: '/onboarding-flow/payment',

  CAMPAIGN_LINJE_5: '/campaigns/linje5',
  CAMPAIGNS_KNOWIT: '/campaigns/knowit',
  CAMPAIGNS_MAKEAWISH: '/campaigns/make-a-wish',
  CAMPAIGNS_MAKEAWISH_SUCCESS: '/campaigns/make-a-wish/success',

  // Test Prep
  TEST_PREP: '/test',
  TEST_START: '/test/start',
  TEST_GENERATE: '/test/generate',
  TEST_EXAM: '/test/exam',
  TEST_HISTORY: '/test/history',
  TEST_SUMMARY: '/test/summary',
}

export default ROUTES
